import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getGiveawayList = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/briefs/giveaways?${queries}` });

  return data?.data;
};

export default getGiveawayList;
